// src/components/shared/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, firstLogin } = useAuth();

  // Not logged in → go to login page
  if (!user) return <Navigate to="/login" replace />;

  // First login → must set new password first
  if (firstLogin) return <Navigate to="/set-password" replace />;

  // Role restriction — if allowedRoles passed, check it
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}